module.exports = __webpack_public_path__ + "img/anasazi.93fe19b6.png";